// extracted by css-extract-rspack-plugin
export default {"fileButton":"SxyZpaRtYAzXHIY4"};